<template>
  <div class="shops-index">
    <header-component></header-component>
    <md-layout md-align="center">
      <md-layout md-flex="90">
        <el-tabs @tab-click="initQuery" type="card" class="shops-index-tabs">
          <el-tab-pane label="キーワードから探す">
            <el-form class="shops-index-search-form":inline="true" @submit.native.stop.prevent="searchInit(query)">
              <el-form-item>
                <el-input v-model="query" placeholder="例：自由が丘"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button v-on:click="searchInit(query)" type='submit'>検索</el-button>
              </el-form-item>
            </el-form>
            <img src="../../assets/algolia.png">
          </el-tab-pane>
          <el-tab-pane label="都道府県から探す">
            <el-button v-on:click="switchTab">都道府県リスト</el-button>
            <table class="shops-index-prefectures-table" v-show="showPrefectures">
              <tr v-for="(prefectures, area) in prefectures">
                <th class='pref-menu-region' nowrap>{{ area }}</th>
                <td>
                  <a v-for="prefecture in prefectures" class='pref-link' v-on:click="searchByPrefecture(prefecture)">{{ prefecture }}</a>
                </td>
              </tr>
            </table>
          </el-tab-pane>
        </el-tabs>
      </md-layout>
      <md-layout class="shop-card" md-tag="md-card" md-column md-flex="90" v-for="shop in shops" :key="shop.id">
        <md-card-content>
          <h2><router-link :to="{ name: 'ShopsShow', params: { id: shop.doc_id }}">{{ shop.name }}</router-link></h2>
          <p class="shopcard-content">
            <md-icon class="location_on">location_on</md-icon>
            {{ shop.place }}
            <md-icon class="md-train">train</md-icon>
            {{ shop.station }}
          </p>
          <p>
          <p class="shopcard-content" v-for="comment in shop.comments" :key="comment.id">
            <md-icon class="md-chat_bubble_outline">chat_bubble_outline</md-icon>
            {{ comment.content }}
          </p>
        </md-card-content>
      </md-layout>
    </md-layout>
    <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
      <span slot="no-more">
        これ以上居酒屋データはありません
      </span>
    </infinite-loading>
  </div>
</template>

<script>
import HeaderComponent from '../Header.vue'
import InfiniteLoading from 'vue-infinite-loading'
import firebaseApp from '../../firebaseApp'
import Algoliasearch from 'algoliasearch'

const client = Algoliasearch('OXOD20TV7U', '2f00c5ddabeff16af7a8a44d692acaf2')
const index = client.initIndex('shops')

const db = firebaseApp.firestore()
const PER_COUNT = 25
var next = db.collection('shops').limit(PER_COUNT)
var nextWhenSearchByPrefecture = db.collection('shops').limit(PER_COUNT)
const PREFECTURES = {
  '北海道': ['北海道'],
  '東北': ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県'],
  '関東': ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県'],
  '中部': ['新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県'],
  '関西': ['三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県'],
  '中国': ['鳥取県', '島根県', '岡山県', '広島県', '山口県'],
  '四国': ['徳島県', '香川県', '愛媛県', '高知県'],
  '九州': ['福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
}
let data = {
  shops: [],
  query: '',
  page: 0,
  showPrefectures: false,
  searchPrefecture: '',
  prefectures: PREFECTURES
}

export default {
  name: 'shops-index',
  data: function () {
    return data
  },
  components: {
    InfiniteLoading,
    HeaderComponent
  },
  methods: {
    initQuery: function () {
      data.query = ''
    },
    switchTab: function () {
      data.showPrefectures = !data.showPrefectures
    },
    searchByPrefecture: function (prefecture) {
      this.switchTab()
      this.$refs.infiniteLoading.stateChanger.reset()
      db.collection('shops').where('prefecture', '==', prefecture).limit(PER_COUNT).get().then((querySnapShots) => {
        data.searchPrefecture = prefecture
        data.shops = []
        querySnapShots.forEach(function (snapShot) {
          data.shops.push(Object.assign(snapShot.data(), {doc_id: snapShot.id}))
        })
        var lastVisible = querySnapShots.docs[querySnapShots.docs.length - 1]
        nextWhenSearchByPrefecture = db.collection('shops').where('prefecture', '==', prefecture).limit(PER_COUNT).startAfter(lastVisible)
        this.$refs.infiniteLoading.stateChanger.loaded()
      })
    },
    search: function (query) {
      return new Promise((resolve, reject) => {
        index.search({
          query: query,
          page: data.page
        }).then(responses => {
          if (responses.hits.length === 0) {
            /* eslint-disable */
            reject()
          } else {
            responses.hits.forEach((doc) => {
              data.shops.push(Object.assign(doc, {doc_id: doc.objectID}))
            })
          }
          resolve()
        })
      })
    },
    searchInit: function (query) {
      data.shops = []
      data.page = 0
      data.query = query
      data.searchPrefecture = ""
      this.$refs.infiniteLoading.stateChanger.reset()
      this.search(data.query)
    },
    infiniteHandler ($state) {
      // 都道府県検索のとき
      if (data.searchPrefecture !== '') {
        nextWhenSearchByPrefecture.get().then((documentSnapshots) => {
          if (documentSnapshots.docs.length === 0) {
            $state.complete()
          }
          documentSnapshots.forEach(function (snapShot) {
            data.shops.push(Object.assign(snapShot.data(), {doc_id: snapShot.id}))
          })
          var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1]
          nextWhenSearchByPrefecture = db.collection('shops').where('prefecture', '==', data.searchPrefecture).limit(PER_COUNT).startAfter(lastVisible)
        })
        .then(function () {
          $state.loaded()
        })
        .catch(function () {
          $state.loaded()
          $state.complete()
        })
      } else if (data.query === '') {
        // 検索してない普通の時の動き
        next.get().then(function (documentSnapshots) {
          if (documentSnapshots.docs.length === 0) {
            $state.complete()
          }
          documentSnapshots.forEach(function (snapShot) {
            data.shops.push(Object.assign(snapShot.data(), {doc_id: snapShot.id}))
          })
          var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1]
          next = db.collection('shops').startAfter(lastVisible).limit(PER_COUNT)
        }).then(function () {
          $state.loaded()
        })
      } else {
        // キーワード検索のときの動き
        data.page += 1
        this.search(data.query)
          .then(function () {
            $state.loaded()
          })
          .catch(function () {
            $state.loaded()
            $state.complete()
          })
      }
    }
  }
}
</script>
<style scoped>
.shopcard-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shops-index-prefectures-table {
  border-style: none;
}
.shops-index-tabs {
  width: 100%;
}

.shops-index-search-form {
  margin-bottom: -20px;
}

.pref-menu-region {
  text-align: center;
}

.pref-link {
  text-align: center;
  margin-right: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/Shops/Index.vue